import { render, staticRenderFns } from "./CreateIssuanceInvoiceView.vue?vue&type=template&id=da4581bc&scoped=true"
import script from "./CreateIssuanceInvoiceView.vue?vue&type=script&lang=js"
export * from "./CreateIssuanceInvoiceView.vue?vue&type=script&lang=js"
import style0 from "./CreateIssuanceInvoiceView.vue?vue&type=style&index=0&id=da4581bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4581bc",
  null
  
)

export default component.exports